<div class="slipcase-item-cont">
  <div class="row">
    @if (newsItem.featured_image_url !== undefined) {
      <div class="col-3 d-flex align-items-center">
        <a
          [attr.href]="newsItem.web_url"
          rel="noopener"
          target="_blank"
          (mouseup)="newsItemClicked($event)"
          class="news-feed-featured-img">
          <picture>
            <img
              [attr.src]="newsItem.featured_image_url"
              [attr.alt]="newsItem.heading"
              [attr.title]="newsItem.heading"
              onerror="this.style.display = 'none'" />
          </picture>
        </a>
      </div>
    }
    <div class="col d-flex align-items-center">
      <div
        [ngClass]="{ 'pt-0 pb-0': !isMostPopular, 'pt-0 pb-0 most-popular': isMostPopular }"
        class="">
        <h5 class="pb-2 mb-0">
          @if (newsItem.paywalled) {
            <i class="pe-2 far fa-lock padlock"></i>
          }
          <a
            [attr.href]="newsItem.web_url"
            rel="noopener"
            target="_blank"
            (mouseup)="newsItemClicked($event)">
            {{ newsItem.heading }}
          </a>
        </h5>
        <p class="pb-2 mb-0">
          {{ newsItem.excerpt }}
        </p>
        @if (showTopics || showItemHostname || showPublishDate) {
          <div class="mb-0 pb-0">
            @if (showTopics) {
              <div class="topics form-control-label pb-1">
                @for (topic of newsItem.topics; track topic; let last = $last) {
                  <span>{{ topic.name }}</span>
                  @if (!last) {
                    <span>; </span>
                  }
                }
              </div>
            }
            @if (showItemHostname) {
              <div>
                <a
                  [href]="newsItem.web_url"
                  class="source"
                  style="text-decoration: none"
                  rel="noopener"
                  target="_blank"
                  (mouseup)="newsItemClicked($event)">
                  {{ hostnameUrl }}
                </a>
              </div>
            }
            @if (showPublishDate) {
              <div class="date">{{ getDate(newsItem.date) | timeAgo }}</div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
